import React, { useEffect, useState } from 'react';
import { useUserStore } from 'src/hooks/admin/user';
import { useAdminCommonStore } from 'src/hooks/admin/adminCommon';
import Helper from 'src/helper/Helper';
import useReduxState from 'src/hooks/useReduxState';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { useObjCommonFilterStore } from '../../../hooks/objCommonFilter';
import { Tooltip } from 'src/component/Global/Tooltip';

import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';


const UserSearchAcct = () => {
    const [{ orgList }, { get_organization_detail }, { }] = useAdminCommonStore();
    const [{ }, { }, { set_search_acct_list, }] = useUserStore();
    const defaultModel = { accountName: "", accountNumber: "", salesOrg: [] };
    const [searchData, setSearchData] = useState(defaultModel);
    const [{ filter_list }, { }, { clear_all_filter, set_filter_list }] = useObjCommonFilterStore();
    const [disableSearch, setDisableSearch] = useReduxState(true, 'setDisableAccountSearch');
    const [validationError, setValidationError] = useState({ minTwoErr: false, atleastTwoErr: false })
    const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const keyMap = {
        accountName: "Account Name",
        accountNumber: "Account Number",
        salesOrg: "Sales Org"
    }

    useEffect(() => {
        async function fetchHere() {
            get_organization_detail();
        }
        fetchHere();
    }, []);

    useEffect(() => {
        if (!filter_list || Object.entries(filter_list).length === 0) {
            setSearchData(defaultModel)
        } else {
            const searchingData = defaultModel
            searchingData.accountName = filter_list?.accountName?.searchKeyword || ''
            searchingData.accountNumber = filter_list?.accountNumber?.searchKeyword || ''
            searchingData.salesOrg = filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr : [];
            setSearchData(searchingData)
        }
    }, [filter_list]);

    const onSearch = (e) => {
        e.preventDefault();
        const isSearchDataEmpty = Object.values(searchData).every(value => !value);

        if (isSearchDataEmpty) {
            system_alert_indicator({
                name: "sponserUserAcctError",
                message: "At least one of the field from Account Number or Account Name should have search keywords to display results",
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            });
            return;
        }

        const filterList = Object.entries(searchData)
            .filter(([key, value]) => Helper.valueIsNotNull(value)).map((v) => {
                const val = {
                    searchType: keyMap[v[0]],
                    key: v[0],
                    [Array.isArray(v[1]) ? 'searchKeywordArr' : 'searchKeyword']: v[1],
                }
                return val;
            });
        const filterListObject = filterList?.reduce((acc, curr) => {
            acc[curr.key] = curr;
            return acc;
        }, {});

        if (filterList.length === 0) {
            system_alert_indicator({
                name: "sponserUserAcctError",
                message: "Enter at least 2 characters without zero",
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            });
            return;
        }

        // Clear Alert
        remove_system_alert_indicator("sponserUserAcctError");
        set_filter_list(filterListObject);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchData({
            ...searchData,
            [name]: name === "accountNumber" ? value.replace(/[^0-9]/gi, '') : value,
        });
    };

    useEffect(() => {
        if (searchData.accountNumber?.trim()?.length > 0 && searchData.accountNumber?.trim()?.length < 2) {
            setDisableSearch(true);
            return;
        }
        if (searchData.accountName?.length > 0 && searchData.accountName?.length < 2) {
            setDisableSearch(true);
            return;
        }
        if ((searchData.accountNumber?.trim()?.length > 0 || searchData.accountName?.length > 0)) {
            if (searchData.accountNumber?.trim()?.length > 0 && (!/^(?!0+$)[0-9]+$/.test(searchData.accountNumber?.trim()))) {
                setDisableSearch(true);
                return;
            }
            setDisableSearch(false);
            return;
        }
        setDisableSearch(true);
    }, [searchData]);

    const onClear = async () => {
        set_search_acct_list();
        setSearchData(defaultModel)
        setValidationError({ atleastTwoErr: false, minTwoErr: false });
        remove_system_alert_indicator("sponserUserAcctError")
        clear_all_filter();
    };
    const onBlurAccName = (event) => {
        if (event.target.value && event.target.value.length < 2) {
            setValidationError(prevState => ({ ...prevState, minTwoErr: true }));
        } else {
            setValidationError(prevState => ({ ...prevState, minTwoErr: false }));
        }
    }
    const onBlurAccNumber = (event) => {
        if (searchData.accountNumber?.trim()?.length > 0 && (!/^(?!0+$)[0-9]+$/.test(searchData.accountNumber.trim()))) {

            system_alert_indicator({
                name: "sponserUserAcctError",
                message: "Enter keyword greater than zero",
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            });

        } else if (searchData.accountNumber?.trim()?.length < 2) {
            remove_system_alert_indicator("sponserUserAcctError")
            setValidationError(prevState => ({ ...prevState, atleastTwoErr: true }));
        } else {
            remove_system_alert_indicator("sponserUserAcctError")
            setValidationError(prevState => ({ ...prevState, atleastTwoErr: false }));
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === ' ') {
            event.preventDefault();
        }
    };

    return (
        <>
            <div className='bg-grey2 p-3 darkgray-border border-end-0 border-start-0'>
                <form onSubmit={(e) => { (!(disableSearch)) && onSearch(e) }} >
                    <div className='row'>
                        <div className='col-md-12 d-flex align-items-center'>
                            <h5 className='text-darkgreen mt-0 font-arial me-2'><strong>Search for Account</strong></h5>
                            <Tooltip
                                position={'bottom center'}
                                opener={() => (<i className="fa fa-info-circle me-1 font-13 text-black-stone font-16" />)}
                                content={() => 'Account Name or Account Number is mandatory to perform account search'}
                            />
                        </div>
                        <div className='col-md-4 mb-3'>
                            <label htmlFor="accountNumber">Account Number </label>
                            <input className={"ps-2 form-control form-control-sm mb-0" + (validationError.atleastTwoErr && "border border-danger")}
                                name="accountNumber"
                                placeholder="Account Number"
                                type="text"
                                value={searchData.accountNumber?.trim()}
                                onChange={handleInputChange}
                                onBlur={onBlurAccNumber}
                                onKeyDown={handleKeyDown}
                            />
                            {validationError.atleastTwoErr && <p className="text-red">
                                Enter at least 2 characters without zero.
                            </p>}
                        </div>
                        <div className='col-md-4 mb-3'>
                            <label htmlFor="accountName">Account Name </label>
                            <input className={"ps-2 form-control form-control-sm mb-0 " + (validationError.minTwoErr && "border border-danger")}
                                name="accountName"
                                placeholder="Account Name"
                                type="text"
                                value={searchData.accountName}
                                onChange={handleInputChange}
                                onBlur={onBlurAccName}
                            />
                            {validationError.minTwoErr && <p className="text-red">
                                Please enter at least 2 characters.
                            </p>}

                        </div>

                        <div className='col-md-4 mb-3 multiselect pe-0'>
                            <label>Sales Org</label>

                            <ReactMultiSelectCheckboxes
                                placeholder={"Select Sales Org"}
                                value={searchData.salesOrg}
                                options={(orgList && orgList.length > 0) ? orgList.map(v => ({ label: v, value: v })) : []}
                                onChange={(option) => {
                                    handleInputChange({ target: { name: 'salesOrg', value: option } })
                                }} />

                        </div>
                    </div>
                    <div className="row bs5 mt-2">
                        <div className="col-12 text-sm-end">
                            <button type="button" className="bs5 btn btn-secondary me-2 w110" onClick={() => onClear()}>Clear</button>
                            <button type="submit" className="bs5 btn btn-primary w110" disabled={disableSearch} >Search</button>
                        </div>
                    </div>
                </form>
            </div>

        </>
    )
}

export default UserSearchAcct;